import { Component, Output, EventEmitter } from '@angular/core';

import { AppService } from '../../../app.service';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { PersonViewService } from '../../../PersonComponent/PersonViewComponent/person.view.service';
import { EmployerViewService } from '../../../EmployerComponent/EmployerViewComponent/employer.view.service';
import { NewProjectViewService } from '../../../ProjectComponent/NewProjectViewComponent/new.project.view.service';
import { NewRegisterViewService } from '../../../RegisterComponent/NewRegisterViewComponent/new.register.view.service';
import translateJson from "../../../../translate.json";
import { EntityTypes } from '../../enum/EntityTypes';

@Component({
    selector: 'archive-modal-comp',
    providers: [AppService, NgxSmartModalService, PersonViewService, EmployerViewService, NewProjectViewService, NewRegisterViewService],
    templateUrl: './archive.modal.component.html',
    styleUrls: ['./archive.modal.component.css']
})
export class ArchiveModalComponent {

    //modalData: string[] = ["", ""];
    private entityObject: EntityObject;
    private entityShow: boolean;
    private i18 = translateJson.i18;
    private entityType = EntityTypes;

    @Output() onArchiveComplete = new EventEmitter();

    constructor(
        private appService: AppService,
        private ngxSmartModalService: NgxSmartModalService,
        private personViewService: PersonViewService,
        private employerViewService: EmployerViewService,
        private newProjectViewService: NewProjectViewService,
        private newRegisterViewService: NewRegisterViewService
    ){
        this.entityShow = false;
    }

    /**
    * Method used when the final modal is setup and ready to be shown
    * @param data Sets the modal data to be displayed by respective view
    */
    public setEntityData(data) {
        this.entityObject = data;
        if (this.entityObject.dataArray.length > 0) {
            this.entityShow = true;
        }
    }

    /**
    * Default method used to create the ModalData object
    * @param title    Title of component to be shown in table (e.g. Registerkontroll)
    * @param objectType    The entity type (e.g. rk)
    * @param objectArray    The array of objects to be displayed (e.g. a list of rk data)
    * @param tableHeader1    The first table header
    * @param tableHeader2    The second table header
    * @param tableHeader3    The third table header
    */
    public createModal( title: string, objectArray:ModalObject[], 
                        tableHeader1: string, tableHeader2: string, tableHeader3: string) {
        return new ModalData(title, objectArray, tableHeader1, tableHeader2, tableHeader3);
    }

    public createModalObject(entry1: string, entry2: string, entry3: string) {
        return new ModalObject(entry1, entry2, entry3);
    }

    public createEntityObject(displayName: string, entityUuid:string, dataArray:ModalData[]) {
        return new EntityObject(displayName, entityUuid, dataArray);
    }

    public setupDefaultRkData() {
        return this.createModal(this.i18.rk.form.rkMainLabel, [], this.i18.rk.form.rkDiaryLabel, this.i18.rk.form.rkStatusLabel, this.i18.rk.form.rkCauseShortLabel);
    }

    public setupDefaultSuaData() {
        return this.createModal(this.i18.sua.form.suaMainLabel, [], this.i18.sua.form.suaLevelLabel, this.i18.sua.form.suaBranchLabel, this.i18.sua.form.suaAgreementNameLabel);
    }

    public setupSuaSubSupplierData() {
        return this.createModal(this.i18.sua.form.suaSubSupplierMainLabel, [], this.i18.sua.form.suaLevelLabel, this.i18.sua.form.suaBranchLabel, this.i18.sua.form.suaAgreementNameLabel);
    }

    public setupDefaultPerson() {
        return this.createModal(this.i18.person.form.personMainLabel, [], this.i18.person.form.personSsnLabel, this.i18.person.form.personFirstNameLabel, this.i18.person.form.personLastNameLabel);
    }

    private archiveConfirmed(uuidToRemove, entity) {
        if(entity === this.entityType.PERSON) {
            this.personViewService.softDeletePerson(uuidToRemove)
              .subscribe(
                data => this.archiveCompleted(this.entityType.PERSON),
                error => console.log(error)
              )
        } else if(entity === this.entityType.SUPPLIER) {
            this.employerViewService.updateEmployerStatus(uuidToRemove).subscribe(
                data => this.archiveCompleted(this.entityType.SUPPLIER),
                error => console.log(error)      
            )
        } else if(entity === this.entityType.PROJECT) {
            this.newProjectViewService.archiveProject(uuidToRemove).subscribe(
              data => this.archiveCompleted(this.entityType.PROJECT),
              error => console.log(error)
            )
        } else if(entity === this.entityType.RK) {
            this.newRegisterViewService.archiveRegisterControl(uuidToRemove).subscribe(
                data => this.archiveCompleted(this.entityType.RK),
                error => console.log(error)
            )
        }

    }

    /**
        * Set the URL-route to the specified route
        * @param route Route to change to
    */
    private archiveCompleted(entity) {
        this.closeModal();
        this.onArchiveComplete.next();
    }

    private closeModal() {
        this.ngxSmartModalService.getModal('archiveModal').close();
    }

    public pop() {
        this.ngxSmartModalService.setModalData(this.entityObject, 'archiveModal', true);
        this.ngxSmartModalService.getModal('archiveModal').open();
    }
}


export class EntityObject {
    displayName: string; 
    entityUuid: string;
    dataArray: ModalData[];

    constructor(data1: string, data2:string, data3:ModalData[]){
        this.displayName = data1;
        this.entityUuid = data2;
        this.dataArray = data3;
    }
}

export class ModalData {
    title: string;
    objectType: string;
    objectArray: ModalObject[];
    tableHeader1: string;
    tableHeader2: string;
    tableHeader3: string;

    constructor(data1: string, data2:ModalObject[], 
                data3: string, data4: string, data5: string) {
        this.title = data1;
        this.objectArray = data2;
        this.tableHeader1 = data3;
        this.tableHeader2 = data4;
        this.tableHeader3 = data5;
    }
}

export class ModalObject {
    entry1: string;
    entry2: string;
    entry3: string;

    constructor(data1: string, data2:string, data3:string){
        this.entry1 = data1;
        this.entry2 = data2;
        this.entry3 = data3;
    }
}